module.exports = __webpack_public_path__ + "static/media/youtubebanner.35321f16.png";